import { SHIPPER_GUIDE_API_URL } from '../environment'
import { HttpClient } from './HttpClient'

export class ShipperGuideClient extends HttpClient {
  constructor({ withToken = false }: { withToken?: boolean } = {}) {
    super(SHIPPER_GUIDE_API_URL, {
      // undefined lets the HttpClient constructor fall back to HttpClient.requestInterceptor
      // (set by HttpClient.setup() in initApplication). null explicitly disables it.
      requestInterceptor: withToken ? undefined : null,
      responseInterceptor: null,
    })
  }
}
